<template>
  <nav class="normal footer-sitemap">
    <div class="common-section">
      <el-row class="box" type="flex" justify="space-around">
        <el-col :xs="24" :sm="3">
          <div class="grid-content">
            <div class="box-element">
              <div class="inner-box">
                <h3><router-link to="/">首页</router-link></h3>
                <h3><router-link to="/company/">企业简介</router-link></h3>
                <ul class="list list-vertical">
                  <li><router-link :to="{name:'company', query:{flag:2}}">企业历史</router-link></li>
                </ul>
                <h3><router-link to="/news">企业资讯</router-link></h3>
              </div>
            </div>
          </div></el-col>
        <el-col :xs="24" :sm="5">
          <div class="grid-content">
            <div class="box-element">
              <div class="inner-box">
                <h3><router-link to="/products">产品分类</router-link></h3>
                <ul class="list list-vertical">
                  <li v-for="(item,index) in catalog" :key="item.id"><router-link :to="{path: `/product/${item.id}`}">{{item.name}}</router-link></li>
                </ul>
              </div>
            </div>
          </div></el-col>
        <el-col :xs="24" :sm="5">
          <div class="grid-content">
            <div class="box-element">
              <div class="inner-box">
                <h3><router-link to="/agency">销售代理</router-link></h3>
                <h3><router-link to="/contact">联系我们</router-link></h3>
                <ul class="list list-vertical">
                  <!--<li>电话：022-5811-1503</li>-->
                  <li>电话：0519-85603273</li>
                  <!--<li>传真：022-5811-1508</li>-->
                  <li>传真：0519-85603275</li>
                </ul>
              </div>
            </div>
          </div></el-col>
        <el-col :xs="24" :sm="3">
          <div class="grid-content">
            <div class="box-element">
              <div class="inner-box">
                <h3><a href="">合作企业</a></h3>
                <ul class="list list-vertical">
                  <!-- <li><img src="../assets/com_01.jpg" alt=""></li> -->
                  <li><img src="../../static/logo/com_01.jpg" alt=""></li>
                  <!-- <li><img src="../assets/com_02.jpg" alt=""></li> -->
                  <li><img src="../../static/logo/com_02.jpg" alt=""></li>
                </ul>
              </div>
            </div>
          </div></el-col>
      </el-row>
    </div>
  </nav>
</template>
<script>
  import { mapState } from 'vuex'
  export default {
    computed: {
      ...mapState(['catalog'])
    },
    methods: {
    }
  }
</script>
<style type="text/scss" lang="scss" rel="stylesheet/scss" scoped>
  @import "../styles/declaration";
  .footer-sitemap {
    margin-top: 50px;
    padding-bottom: 30px;
    text-align: center;
    background-color: #f5f5f5;
  }
  .common-section {
    /*padding: 35px 0 45px;*/
    font-size: $font-size;
    max-width: 1200px;
    margin: auto;
  }
  .box-element {
    /*width: 25%;*/
    text-align: left;
    /*float: left;*/
    vertical-align: top;
    h3 {
      line-height: 1.4;
      padding-top: 20px;
      a {
        font-size: 14px;
        padding-left: 0;
        /*padding-right: 10px;*/
        padding-bottom: 5px;
        text-align: left;
        font-weight: bold;
        color: #000;
        display: inline-block;
        border-bottom: solid 1px #000;
        &:hover{
          text-decoration: none;
        }
      }
      &.mt40 {
        margin-top: 40px;
      }
    }
    .list a {
      margin-top: 10px;
      text-align: left;
      color: #333;
      font-size: $font-size - .02rem;
      line-height: 1.3;
    }
    .list img{
      margin-top: 10px;
    }
    .figure {
      margin-top: 15px;
      img {
        margin-right: 10px;
      }
    }
  }
  .fs-products, .fs-solution {
    width: 236px;
  }
  .fs-information {
    width: 241px;
  }
  .fs-other {
    width: 202px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .sitemap .box-element {
    margin-right: 25px;
    &:last-child {
      margin-right: 0;
    }
  }
  .f-d .box-element,
  .bottom .box-element {
    display: block;
    text-align: right;
    margin-right: 0;
    p {
      min-width: 150px;
      text-align: center;
      a {
        display: block;
        padding: 5px 24px 7px;
        color: #ffffff;
        line-height: 1.4;
      }
    }
  }
  .bottom {
    padding: 20px 0;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
    & > .box-element {
      vertical-align: middle;
      width: 19%;
      display: inline-block;
    }
    & > .box-element:first-child {
      width: 80%;
    }
    .block-element:first-child {
      padding-right: 25px;
      white-space: nowrap;
      a {
        color: #333;
        padding-left: 0;
      }
    }
    .block-element:last-child {
      padding-right: 0;
      p {
        line-height: 1.25;
        text-align: left;
      }
    }
  }
  @media screen and (min-width: 768px) {
    .box:first-child .box-element a:hover {
      text-decoration: underline;
    }
    .box:first-child .box-element h3 a:hover{
      text-decoration: none;
    }
  }
  @media screen and (max-width: 767px) {
    .footer-sitemap {
      margin-top: 0;
      background-color: #1b1b1b;
      border-bottom: solid 2px #1b1b1b;
      .box-element h3 a{
        border-bottom: none;
        color: #ffffff;
        position: relative;
        display: block;
      }
      .box-element h3 a:after{
        content: "";
        position: absolute;
        left: auto;
        right: 25px;
        width: 12px;
        height: 12px;
        background: url('../assets/icons/arrow_white.png') no-repeat center;
        background-size: cover;
      }
      .list-vertical{
        display: none;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/Sitemap.vue